module.exports = __webpack_public_path__ + "img/octarine_core.ba83a168.png";